// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerMainContent-cls1_KPu","cls2":"VideoPlayerMainContent-cls2_unR VideoPlayerMainContent-cls1_KPu"};